import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ImportAnnotationsBl } from '../../importAnnotations.bl';
import { ImportAnnotationsButton } from './ImportAnnotationsButton';

export const ImportAnnotationsButtonContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);

  const { projectId } = useParams<{ projectId: string }>();

  const handleStartImport = (): void => {
    bl.startImport(projectId);
  };

  return <ImportAnnotationsButton onStartImport={handleStartImport} />;
});
